import DefaultState from './DefaultState';
import ImageUploaderConfigurator from './ImageUploaderConfigurator';
import ImageUploaderPreview from './ImageUploaderPreview';

const index = {
    label: 'Image',
    type: 'imageUploader',
    defaultState: DefaultState,
    configurator: ImageUploaderConfigurator,
    preview: ImageUploaderPreview,
};

export default index;
